<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">Order Information</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li class="breadcrumb-item">
                                        <router-link to="/my-orders">My-Orders</router-link>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">{{details.orderNo}}</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <div class="container mt-5">
            <div class="row">
                <div class="col-md-5">
                    <div class="card">
                        <div class="card-header">
                            Summary
                        </div>
                        <table class="table mb-0 table-borderless">
                            <tbody>
                            <tr>
                                <th>Order Number</th>
                                <td>{{details.orderNo}}</td>
                            </tr>
                            <tr>
                                <th>Total</th>
                                <td>Ksh. {{Math.round(details.total_price)}}</td>
                            </tr>

                            <tr v-if="details.coupon_id">
                                <th>Coupon</th>
                                <td><span class="text-success">{{details.coupon.code}}</span></td>
                            </tr>

                            <tr v-if="details.coupon_id">
                                <th>Discount</th>
                                <td>Ksh: {{-Math.round(details.discount)}}</td>
                            </tr>

                            <tr>
                                <th>Sub-Total</th>
                                <td>Ksh: {{Math.round(details.sub_total)}}</td>
                            </tr>

                            <tr>
                                <th>Order Status</th>
                                <td>
                                    <span v-if="details.status == 'pending'"
                                          style="color: blue;">{{details.status}}</span>
                                    <span v-if="details.status == 'cancelled'"
                                          style="color: red;">{{details.status}}</span>
                                    <span v-if="details.status == 'completed'"
                                          style="color: green;">{{details.status}}</span>
                                    <span v-if="details.status == 'in-transit'"
                                          style="color: yellow;">{{details.status}}</span>
                                </td>
                            </tr>

                            <tr>
                                <th>Payment Status</th>
                                <td>
                                    <span v-if="details.paid == 1" class="badge badge-success">paid</span>
                                    <span v-if="details.paid == 0" class="badge badge-warning">not paid</span>
                                </td>
                            </tr>

                            <tr v-if="details.paid == 0">
                                <th>Pay</th>
                                <td>
                                    <button type="button" class="btn btn-success btn-sm" @click="newModal">
                                        Pay now
                                    </button>
                                </td>
                            </tr>

                            <tr v-if="details.status == 'pending' && details.paid == 0">
                                <th>Cancel Order</th>
                                <td>
                                    <button type="button" class="btn btn-danger btn-sm" @click="cancelOrder">
                                        <i class="fa fa-window-close"></i>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="table-responsive">
                            <table class="table mb-0">
                                <tbody>

                                <tr>
                                    <th>Items in order</th>
                                    <td>{{details.items.length}}</td>
                                </tr>

                                <tr>
                                    <th>Phone</th>
                                    <td>{{details.phone}}</td>
                                </tr>

                                <tr>
                                    <th>Delivery</th>
                                    <td>
                                        <span v-if="details.deliver == 'home'">Deliver at my home</span>
                                        <span v-if="details.deliver == 'office'">Pickup at your office</span>
                                    </td>
                                </tr>

                                <tr v-if="details.deliver == 'home'">
                                    <th>County</th>
                                    <td>{{details.county}}</td>
                                </tr>

                                <tr v-if="details.deliver == 'home'">
                                    <th>Delivery Address</th>
                                    <td>{{details.address}}</td>
                                </tr>

                                <tr v-if="details.deliver == 'home'">
                                    <th>Delivery Location Name</th>
                                    <td>{{details.LocationName}}</td>
                                </tr>

                                <tr>
                                    <th>Date</th>
                                    <td>{{moment(details.created_at).format('MMMM Do YYYY, h:mm a')}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- /.col-lg-3 -->

                <div class="col-md-7">
                    <div class="card card-outline-secondary mb-4">
                        <div class="card-header">
                            Items in order
                        </div>
                        <div class="card-body table-responsive">
                            <table class="table table-hover shopping-cart-wrap">
                                <thead class="text-muted">
                                <tr>
                                    <th scope="col">Product</th>
                                    <th scope="col" width="120">Quantity</th>
                                    <th scope="col" width="120">Price (Ksh)</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in details.items" :key="item.id">
                                    <td>
                                        <figure class="media">
                                            <div class="img-wrap"><img :src="item.product.files[0].filePath"
                                                                       class="img-thumbnail img-sm"
                                                                       style="width: 90px;">
                                            </div>
                                            <figcaption class="media-body pl-3">
                                                <h6 class="title text-truncate">{{item.product.title}}</h6>
                                                <dl v-if="item.product.quantity" class="param param-inline small">
                                                    <dt>Quantity:</dt>
                                                    <dd>{{item.product.quantity}}</dd>
                                                </dl>
                                            </figcaption>
                                        </figure>
                                    </td>
                                    <td>
                                        {{item.quantity}}
                                    </td>
                                    <td>
                                        <div class="price-wrap">
                                            <var class="price">{{item.quantity * item.product.price}}</var>
                                            <small class="text-muted">({{Math.round(item.product.price)}} each)</small>
                                        </div> <!-- price-wrap .// -->
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <!-- /.card -->

                </div>
                <!-- /.col-lg-9 -->

            </div>
            <div class="modal fade" id="payModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Make Payment</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form>
                            <div class="modal-body">
                                <div class="form-group">
                                    <label class="float-left">Phone Number</label>
                                    <input type="text" name="phone"
                                           placeholder="0712345678"
                                           class="form-control"
                                           v-model="form.phone">
                                    <small class="float-left mt-1 mb-1" style="color: red" v-if="error && errors.phone">{{
                                        errors.phone[0]
                                        }}</small>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button type="button" @click="makePayments()" class="btn btn-primary">Continue</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="vld-parent">
                <loading name="loader" :active.sync="isLoading"
                         :can-cancel="false"
                         :is-full-page="fullPage"></loading>
            </div>
        </div>
    </div>
</template>

<script>
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    let moment = require('moment');

    export default {
        name: "MyOrderDetails",
        components: {
            Loading
        },
        data() {
            return {
                moment,
                isLoading: false,
                fullPage: true,
                errors: {},
                error: false,
                orderNo: this.$route.params.orderNo,
                details: [],
                form: {
                    phone: this.$auth.user().phone
                }
            }
        },
        methods: {
            makePayments() {
                this.isLoading = true;
                this.axios.post('/shopLocal/pay/' + this.orderNo, this.form).then(() => {
                    this.isLoading = false;
                    $('#payModal').modal('hide');
                    this.$swal({
                        icon: 'success',
                        title: 'Success',
                        text: 'Payment process has been initiated.' +
                            ' Please check your phone to complete payment!'
                    });
                }).catch((error) => {
                    this.isLoading = false;
                    this.error = true;
                    this.errors = error.response.data.errors;
                })
            },
            newModal() {
                $('#payModal').modal('show');
            },
            cancelOrder() {
                this.$swal({
                    title: 'Cancel this order?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, cancel it!',
                    cancelButtonText: 'Close'
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                        this.axios.patch("/shopLocal/cancel-order/" + this.orderNo).then(() => {
                            this.$swal(
                                'Cancelled!',
                                'The order has been cancelled',
                                'success'
                            )
                            this.getDetails();
                        });
                    }
                }).catch(() => {
                    this.$swal("Failed!", "There was something wrong.", "warning");
                })
            },
            getDetails() {
                this.axios.get('/shopLocal/show-details/' + this.orderNo)
                    .then((response) => {
                        this.details = response.data
                    })
                    .catch((error) => {

                    })
            }
        },
        mounted() {
            this.getDetails();
        }
    }
</script>

<style scoped>
    .param {
        margin-bottom: 7px;
        line-height: 1.4;
    }

    .param-inline dt {
        display: inline-block;
    }

    .param dt {
        margin: 0 7px 0 0;
        font-weight: 600;
    }

    .param-inline dd {
        vertical-align: baseline;
        display: inline-block;
    }

    .cart-txt {
        font-size: 25px;
        font-weight: bold;
        color: #4CAF50;
    }

    .total {
        color: #4CAF50;
    }

    .bg {
        background-color: #ffc244;
    }

    .param dd {
        margin: 0;
        vertical-align: baseline;
    }

    .shopping-cart-wrap .price {
        color: #007bff;
        font-size: 18px;
        font-weight: bold;
        margin-right: 5px;
        display: block;
    }

    var {
        font-style: normal;
    }

    .media img {
        margin-right: 1rem;
    }

    .img-sm {
        width: 90px;
        max-height: 75px;
        object-fit: cover;
    }
</style>